import { useUser } from "@saleor/auth";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import { PermissionEnum } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import {
  pendingOrderTrackingUrl,
  PendingOrderUrlQueryParams
} from "@saleor/PendingOrder/urls";
import PendingOrderViewAdmin from "@saleor/PendingOrder/views/PendingOrderViewAdmin";
import PendingOrderViewCustomer from "@saleor/PendingOrder/views/PendingOrderViewCustomer";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  () => ({
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        margin: 0,
        marginBottom: "1.2rem"
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    }
  }),
  { name: "OrderConfirmView" }
);

interface OrderConfirmProps {
  params: PendingOrderUrlQueryParams;
}

const PendingOrderView: React.FC<OrderConfirmProps> = ({ params }) => {
  const intl = useIntl();
  const isPendingOrderTracking = location.pathname?.includes(
    pendingOrderTrackingUrl
  );
  const classes = useStyles();

  const { user } = useUser();

  const isCustomer = useMemo(
    () =>
      !!user.userPermissions.find(
        e => e.code === PermissionEnum.ALL_REPORT_CUSTOMER
      ),
    [user.userPermissions]
  );

  return (
    <>
      <Container>
        <PageHeader
          className={classes.pageHeader}
          title={
            isPendingOrderTracking
              ? intl.formatMessage({
                  defaultMessage: "Pending Order - Order Tracking"
                })
              : intl.formatMessage({
                  defaultMessage: "Pending Order"
                })
          }
        />
        {isCustomer && !user.isSuperuser ? (
          <PendingOrderViewCustomer params={params} />
        ) : (
          <PendingOrderViewAdmin
            params={params}
            isPendingOrderTracking={isPendingOrderTracking}
          />
        )}
      </Container>
    </>
  );
};

export default PendingOrderView;
